// @ts-nocheck

// @index('./*.vue', (f, _) => `import { default as Book${_.pascal(f.name)} } from '${f.path}${f.ext}'`)
import { default as BookBuyNotice } from './buy_notice.vue'
import { default as BookInclusion } from './inclusion.vue'
import { default as BookRadio } from './radio.vue'
import { default as BookStar } from './star.vue'
// @endindex

import { default as BookStore } from '../../book/components/store.vue'

export const BookComponents = {
  // @index('./*.vue', (f, _) => `Book${_.pascal(f.name)},`)
  BookBuyNotice,
  BookInclusion,
  BookRadio,
  BookStar,
  BookStore,
  // @endindex
}
